import { render, staticRenderFns } from "./BaseChanger.vue?vue&type=template&id=2b13ff92&scoped=true&"
import script from "./BaseChanger.vue?vue&type=script&lang=js&"
export * from "./BaseChanger.vue?vue&type=script&lang=js&"
import style0 from "./BaseChanger.vue?vue&type=style&index=0&id=2b13ff92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13ff92",
  null
  
)

export default component.exports